import React, { FunctionComponent, useEffect, useState } from 'react'
import { GetProducts, Group, DatumItem } from '../helper/models/getProducts'
import { useParams } from 'react-router-dom'
import Cart from './Cart'
import Category from './singleRes/Category'
import ProductList from './singleRes/ProductList'
import { ImageProcess } from '../helper/services/imageProcess'
import { productListMobX } from './singleRes/products'

const improcess = new ImageProcess()
const SingleRestaurant: FunctionComponent = (restaurant) => {
  const [render, reRender] = useState(false)
  const [result, setResult] = useState<GetProducts>()
  const { id } = useParams()
  const [lisener, setlisen] = useState(id)
  const api = async () => {
    var body = {
      restaurant: lisener,
      platform: 'web',
    }

    const data = await fetch(
      'https://api.munchies.com.bd/parse/functions/getProducts',
      {
        method: 'POST',
        headers: {
          'X-Parse-Application-Id': 'food',
        },
        body: JSON.stringify(body),
      }
    )
    const jsonData = await data.json()
    productListMobX.assign(jsonData.result.data)

    setResult(jsonData)
  }
  useEffect(() => {
    api()
  }, [lisener])

  return (
    <div className="bg-black ">
      <div className="relative w-full px-16">
        {result?.result && (
          <img
            src={improcess.process(result.result.banner_image)}
            alt="abc"
            className="w-full"
            style={{ height: '250px', objectFit: 'cover', opacity: '0.5' }}
          />
        )}
        <div
          className="table overflow-hidden"
          style={{ position: 'absolute', bottom: '8px' }}
        >
          <div
            className="float-left px-3 my-4 text-3xl text-white h-28"
            style={{ width: '50%' }}
          >
            <div>{result?.result.name}</div>
            <div className="text-xl">{result?.result.cuisines}</div>
            <div className="text-xl text-cyan-400">
              {result &&
                `Delivery Time : ${result?.result.estimated_delivery_time}`}
            </div>
          </div>
          {/* group restaurant list show */}
          <div className="float-left" style={{ width: '50%' }}>
            {result?.result.show_groups && (
              <div className="flex overflow-auto text-white scroll-m-1 whitespace-nowrap">
                {result?.result.group.map((groupEntity) => (
                  <img
                    src={improcess.process(groupEntity.banner_image)}
                    key={groupEntity.objectId}
                    alt={groupEntity.objectId}
                    className="my-4 mr-4 h-28 w-30"
                    onClick={(e) => save(groupEntity)}
                  ></img>
                ))}
              </div>
            )}
          </div>
          {/* group restaurant list show */}
        </div>
      </div>

      {/* product */}
      <div className="table px-16">
        <div className="float-left" style={{ width: '25%', height: '100%' }}>
          {/* category */}
          {result && (
            <Category result={result?.result} key={result?.result._id} />
          )}
          {/* category */}
        </div>
        <div className="float-left mb-3 text-white" style={{ width: '50%' }}>
          {result?.result && (
            <ProductList
              result={result?.result}
              func={addToCartX}
              key={result.result.hub}
            />
          )}
        </div>
        <div className="float-left" style={{ width: '25%', height: '100%' }}>
          <Cart
            update={render}
            key={result?.result.cuisines}
            showCheckOut={true}
          />
        </div>
      </div>
      {/* product */}
    </div>
  )
  function save(
    item: Group
  ): React.MouseEventHandler<HTMLDivElement> | undefined {
    setlisen(item.objectId)
    return
  }
  function addToCartX(
    item: DatumItem
  ): React.MouseEventHandler<HTMLDivElement> | undefined {
    reRender(!render)
    return
  }
}

export default SingleRestaurant
